module.exports = __webpack_public_path__ + "staticVue/img/login-bgimg.2780e1ad.png";